
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { EyeIcon, PencilIcon, UsersIcon, BarChartIcon } from "@/components/icons/owner-icons";
import { NursingHome } from "@/hooks/use-nursing-home";

interface QuickActionsCardProps {
  nursingHome: NursingHome;
}

export function QuickActionsCard({ nursingHome }: QuickActionsCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Quick Actions</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <Button variant="outline" className="w-full justify-start" asChild>
          <Link to={`/nursing-homes/${nursingHome.county_slug}/${nursingHome.nh_slug}`}>
            <EyeIcon className="h-4 w-4 mr-2" />
            View Public Profile
          </Link>
        </Button>
        <Button variant="outline" className="w-full justify-start" disabled>
          <PencilIcon className="h-4 w-4 mr-2" />
          Edit Profile Details
        </Button>
        <Button variant="outline" className="w-full justify-start" disabled>
          <UsersIcon className="h-4 w-4 mr-2" />
          View Inquiries
        </Button>
        <Button variant="outline" className="w-full justify-start" disabled>
          <BarChartIcon className="h-4 w-4 mr-2" />
          View Analytics
        </Button>
      </CardContent>
    </Card>
  );
}
